var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSqLite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 90",
    style: {
      enableBackground: "new 0 0 110 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0F80CC;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#003B57;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SQLite"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.9,22.2H36.4c-2.1,0-3.8,1.7-3.8,3.8v34.7c0,2.1,1.7,3.8,3.8,3.8c0,0,0,0,0,0h20.7 C56.9,54.2,60.4,34.2,67.9,22.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -6.4117,
    y1: 31.9237,
    x2: -6.4117,
    y2: 38.5203,
    gradientTransform: "matrix(4.88 0 0 4.88 81.517 -131.678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#97D9F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#0F80CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0F80CC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,23.3H36.4c-1.5,0-2.7,1.2-2.7,2.6l0,0v32.2c6.9-2.6,17.2-4.9,24.3-4.8C60.2,43.2,63.1,33.1,66.7,23.3z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.2,21.1c-2.3-1.9-4.8-1.1-7.3,1.1l-1.1,1.1C62.3,28,58.3,36.7,57,43.3c0.5,1.1,0.9,2.2,1.1,3.3l0.2,0.7 l0.2,0.8c0,0,0-0.2-0.2-0.6l-0.1-0.3L58.1,47c-0.3-0.7-1.1-2.1-1.4-2.7c-0.3,0.8-0.5,1.6-0.8,2.4c0.7,1.6,1.3,3.2,1.6,4.9 c0,0,0-0.2-0.3-0.9c-0.5-1.1-1-2.1-1.6-3.1c-0.4,1-0.5,2-0.5,3.1c0.4,0.8,0.7,1.6,0.9,2.5c0.4,1.7,0.8,3.4,1,5.1v0.5 c-0.1,1.9,0,3.8,0.1,5.7c0.1,1.9,0.4,3.8,1.1,5.6l0.3-0.2c-0.7-2.7-1-5.5-0.8-8.3c0.3-5.9,1.5-11.8,3.5-17.3 c3.6-9.5,8.6-17.1,13.2-20.8c-4.1,3.8-9.8,16-11.5,20.5c-1.8,4.6-3.1,9.4-4,14.3c1.4-4.3,5.9-6.1,5.9-6.1s2.3-2.7,4.8-6.6 l-4.9,1.3l-1.6,0.7c2.4-1.4,4.9-2.6,7.5-3.6C75.3,36.5,80.5,25.7,75.2,21.1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqLite);
export default __webpack_public_path__ + "static/media/SQLite.0b9369733c006b92c2df129fd88adbbd.svg";
export { ForwardRef as ReactComponent };